import React from 'react'

import Heading from 'presentation/shared/components/Heading'
// import { SurgicalOrderTableFormValues } from 'presentation/hospital/components/SurgicalOrderTable'
import { getSurgicalOrderStatusLabelByEnum } from 'presentation/utils/surgical-order-status'
import { LoadHealthInsurancePlans } from 'domain/usecases/health-insurance/load-health-insurance-plans'
import { LoadSurgeryCenter } from 'domain/usecases/surgery-center/load-surgery-center'
import { ReorderSurgicalOrder } from 'domain/usecases/surgical-order/reorder-surgery'
import { LoadSurgicalOrder } from 'domain/usecases/surgical-order/load-surgical-order'
import { LoadSurgicalOrderDocument } from 'domain/usecases/surgical-order/load-surgical-order-document'
// import { SearchSurgicalOrdersModelNew } from 'service/usecases/search-surgical-orders/remote-search-surgical-orders-new'
import { SurgicalPendencyStatus } from 'domain/entities/surgical-pendency'
import SurgicalOrderDataGrid, {
  OldSurgicalOrderTableFormValues
  // SurgicalOrderDataGridFormValues
} from 'presentation/hospital/components/SurgicalOrderDataGrid'
import ContainerNew from 'presentation/hospital/components/ContainerNew'
import { SearchSurgicalOrdersNew } from 'domain/usecases/surgical-order/search-surgical-orders-new'
import { SearchSurgicalOrdersModelNew } from 'service/usecases/search-surgical-orders/remote-search-surgical-orders-new'
import { RemakeSurgicalOrder } from 'domain/usecases/surgical-order/remake-surgical-order'

type SecretaryAuthorizationLayoutProps = {
  data: any[]
  initialValues?: OldSurgicalOrderTableFormValues
  filterSubmit?: (
    fields?: SearchSurgicalOrdersNew.Params
  ) => Promise<SearchSurgicalOrdersModelNew | undefined>
  loadHealthInsurances?: LoadHealthInsurancePlans
  loadSurgeryCenters?: LoadSurgeryCenter
  reorderSurgicalOrder?: ReorderSurgicalOrder
  loadSurgicalOrder?: LoadSurgicalOrder
  loadSurgicalOrderDocument?: LoadSurgicalOrderDocument
  remakeSurgicalOrder?: RemakeSurgicalOrder
}

export default function SecretaryAuthorizationLayout({
  data,
  initialValues,
  filterSubmit,
  loadSurgeryCenters,
  loadSurgicalOrder,
  reorderSurgicalOrder,
  loadSurgicalOrderDocument,
  loadHealthInsurances,
  remakeSurgicalOrder
}: SecretaryAuthorizationLayoutProps) {
  function handleHeadingLabel(initialValues?: OldSurgicalOrderTableFormValues) {
    if (initialValues?.expired_passwords) return 'Pedidos com senha vencida'

    if (initialValues?.with_authorized_communication)
      return 'Autorização comunicada por paciente'

    if (initialValues?.is_package) return 'Pacote Cirúrgico'

    if (initialValues?.surgical_pendency_status) {
      const isConversation =
        initialValues?.surgical_pendency_type === 'DOCTOR_COMMUNICATION'
      return getPendencyTypeLabel(
        initialValues.surgical_pendency_status,
        isConversation
      )
    }

    if (!initialValues?.status) return 'Total de pedidos'

    return getSurgicalOrderStatusLabelByEnum(initialValues.status)
  }

  function getPendencyTypeLabel(
    pendencyType: SurgicalPendencyStatus,
    isConversation?: boolean
  ) {
    const base = isConversation ? 'Conversas' : 'Pendências'
    if (pendencyType === SurgicalPendencyStatus.PENDENT) {
      return `${base} em andamento`
    }
    if (pendencyType === SurgicalPendencyStatus.ANSWERED) {
      return `${base} à resolver`
    }
    if (pendencyType === SurgicalPendencyStatus.RESOLVED) {
      return `${base} resolvidas`
    }
    return
  }

  const surgicalOrderOrdered = data.sort((firstDate: any, lastDate: any) => {
    return (
      new Date(lastDate?.requested_cancellation?.props?.created_at).valueOf() -
      new Date(firstDate?.requested_cancellation?.props?.created_at).valueOf()
    )
  })

  return (
    <ContainerNew>
      <Heading size="xlarge" color="primary" style={{ marginBottom: '20px' }}>
        {handleHeadingLabel(initialValues)}
      </Heading>
      <SurgicalOrderDataGrid
        data={surgicalOrderOrdered}
        filterInitialValues={initialValues}
        filterSubmit={filterSubmit}
        loadSurgeryCenters={loadSurgeryCenters}
        reorderSurgicalOrder={reorderSurgicalOrder}
        loadSurgicalOrder={loadSurgicalOrder}
        loadSurgicalOrderDocument={loadSurgicalOrderDocument}
        loadHealthInsurances={loadHealthInsurances}
        remakeSurgicalOrder={remakeSurgicalOrder}
      />
    </ContainerNew>
  )
}
